<template>
  <v-app id="app">
    <v-overlay
      v-if="currentUser && !maint && !teacher && !report"
      :value="popup.enabled"
      color="white"
      opacity="0.9"
      z-index="9999"
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          text-align: center;
          color: black;
        "
      >
        <v-icon @click="popup.enabled = false" color="black" class="ml-auto"
          >mdi-close</v-icon
        >
        <h3 v-if="popup.heading">{{ popup.heading }}</h3>
        <img
          :width="$vuetify.breakpoint.xs ? '300rem' : '500rem'"
          v-if="popup.imageUrl"
          :src="popup.imageUrl"
        />
        <p v-if="popup.body">{{ popup.body }}</p>
      </div>
    </v-overlay>
    <b-overlay v-if="!admin && !report" :show="maint" no-wrap fixed>
      <template v-slot:overlay>
        <div id="popup-close">
          <b-icon-x scale="2" @click="popup = false"></b-icon-x>
        </div>
        <div id="popup-content">
          <h1 id="popup-header">We&rsquo;ll be back soon!</h1>
          <div id="popup-icon">
            <b-icon-cone-striped
              scale="7"
              style="color: #ffa20d"
            ></b-icon-cone-striped>
          </div>
          <p id="popup-body">
            Sorry for the inconvenience but we're performing some maintenance at
            the moment. If you need to, you can always
            <a href="mailto:portal@aawaaz.co">contact us</a>, otherwise
            we&rsquo;ll be back online shortly!
          </p>
          <p>&mdash; The Aawaaz Portal Team</p>
          <div id="popup-logout">
            <a @click="logout()">Logout</a>
          </div>
        </div>
      </template>
    </b-overlay>
    <Navigation v-if="currentUser && !report"></Navigation>
    <router-view v-else />
  </v-app>
</template>

<script>
import "../src/assets/scss/chat.scss";
import { mapState } from "vuex";
import Navigation from "./components/Navigation.vue";
const fb = require("../src/firebaseConfig.js");

export default {
  components: { Navigation },
  created: function () {
    // FIXME what about report and assignment notifications
    if (fb.messaging) {
      fb.messaging.onMessage((payload) => {
        if (this.$route.name != "Chat") {
          this.makeToast(payload.notification);
        }
      });
    }
  },
  computed: {
    ...mapState(["currentUser", "maint", "admin", "teacher", "popup"]),
    report() {
      return (
        this.$route.name == "Year-End Report" ||
        this.$route.name == "Baseline Report" ||
        this.$route.name == "Endline Report"
      );
    },
  },
  methods: {
    makeToast(msg) {
      this.$bvToast.toast(msg.body, {
        title: msg.title,
        variant: "info",
        solid: true,
      });
    },
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/login");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>